export const EMAIL_TEMPLATES_PATH = '/app/library/email-templates';
export const NEW_EMAIL_TEMPLATE_PATH = `${EMAIL_TEMPLATES_PATH}/new`;

export const emailTemplatePath = (templateId: string) => `${EMAIL_TEMPLATES_PATH}/${templateId}`;
